export { default } from "./ConfirmPassword";
